// Button.js
import React from "react";
import "./Button.scss";

export default function Button({
  name = "Set Name",
  variant = "primary",
  className = "",
  onClick,
  ariaLabel,
  disabled = false,
  loading = false,
}) {
  return (
    <button
      onClick={!disabled ? onClick : undefined}
      className={`button btn-${variant} ${loading ? "show-spinner" : ""} ${className}`}
      aria-label={ariaLabel || name}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {name}
      {loading && (
        <div className="spinner-border" role="status" aria-live="polite">
          <span className="sr-only">Loading...</span>
        </div>
      )}
    </button>
  );
}